<!--input type="file" webkitdirectory directory multiple/-->

<canvas id="canvas"></canvas>